export default __webpack_public_path__ + "static/1-4fe21eef00a6a2c161a441aea923e934.jpg";